import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { MedicaidService } from '../+products/medicaid/medicaid.service';
import { ProductOrchestratorService } from '../+products/product-orchestrator.service';
import { AppInsightsService } from '../app-insights/appinsights.service';
import { InterviewProductDataProviderService } from './abstract-interview-product-data-provider.service';




@Injectable()
export class InterviewMedicaidDataProviderService extends InterviewProductDataProviderService {

    constructor(store: Store,
        medicaidService: MedicaidService,
        productOrchestratorService: ProductOrchestratorService,
        appInsightsService: AppInsightsService
    ) {
        super(store, medicaidService, productOrchestratorService, appInsightsService);
    }
}
